export default {
	state: {
		orderInfo: {}
	},
	mutations: {
		updateOrderInfo(state, obj) {
            console.log(state, obj)
			state.orderInfo = obj
		}
	},
	getters:{
        getShoppingInfo(state){
            return state.orderInfo
        }
    },
	// actions: {
    //     shoppingInfoAction:({commit}, obj)=>{
    //         console.log(obj, 'obj')
    //         commit("updateShopping")
    //     }
	// }
}


// WEBPACK FOOTER //
// ./src/components/store/billModel.js